import { createContext, useContext } from 'react'
import { CirclesGraph } from '../core/CirclesGraph'
import { GraphColorMode, GraphEvents, HighlightTone } from '../types'

// Rendering context shared by graph elements.
// `graph` is undefined in static rendering (no interactions).
export interface GraphRenderContextValue {
  graph?: CirclesGraph
  colorMode: GraphColorMode
  events: GraphEvents
  isStatic: boolean
  // Circles to emphasize (accent outline, rest dimmed). Purely visual.
  highlightedCircleIds?: string[]
  // Color of that emphasis, 'mine' by default
  highlightTone?: HighlightTone
}

export const GraphRenderContext = createContext<GraphRenderContextValue>({
  colorMode: 'light',
  events: {},
  isStatic: false,
})

export function useGraphRenderContext() {
  return useContext(GraphRenderContext)
}
